import { ConfirmTextModalComponent } from './../../tools/modals/confirm-text-modal/confirm-text-modal.component';
import { LiquidacionRevisionService } from './../../../services/liquidacion-revision.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Component, OnInit, ViewChild } from '@angular/core';
import { SuccessModalComponent } from '../../tools/modals/success-modal/success-modal.component';
import { ErrorModalComponent } from '../../tools/modals/error-modal/error-modal.component';
import { ConfirmModalComponent } from '../../tools/modals/confirm-modal/confirm-modal.component';
import {HelpersService} from "../../../services/tools/helpers.service";
import {WarningModalComponent} from "../../tools/modals/warning-modal/warning-modal.component";
declare var $;

@Component({
  selector: 'app-liquidacion-revision-fondo-ahorro',
  templateUrl: './liquidacion-revision-fondo-ahorro.component.html',
  styleUrls: ['./liquidacion-revision-fondo-ahorro.component.scss']
})
export class LiquidacionRevisionFondoAhorroComponent implements OnInit {
  @ViewChild(SuccessModalComponent) successModal: SuccessModalComponent;
  @ViewChild(ErrorModalComponent) errorModal: ErrorModalComponent;
  @ViewChild(ConfirmModalComponent) confirmModal: ConfirmModalComponent;
  @ViewChild(WarningModalComponent) warningModal: WarningModalComponent;
  @ViewChild(ConfirmTextModalComponent) confirmTextModal: ConfirmTextModalComponent;


  searchText: string = "";
  mostrarListado: boolean = true;
  errors: any = {};
  fechaActual: string;
  fechaInicioLiquidacion: string;
  fechaFinLiquidacion: string;
  processing: any = false;
  changing: boolean = false;
  /* selected */
  liquidacionSelected: any = undefined;
  fondoSelected: any = undefined;
  notasUrl: string;
  movimientosUrl: string;
  defaultImage: string;
  notasRechazo: string;

  //CL
  private idLiquidacion:any;

  constructor(private liquidacionRevisionService: LiquidacionRevisionService,
              private helperService: HelpersService,
              private activedRoute: ActivatedRoute,
              private router: Router) {
                this.deleteLiquidacion = this.deleteLiquidacion.bind(this);
                this.sendLiquidacion = this.sendLiquidacion.bind(this);
                this.saveFondo = this.saveFondo.bind(this);
                this.cancelChanges = this.cancelChanges.bind(this);
                this.aprobarLiquidacion = this.aprobarLiquidacion.bind(this);
                this.rechazarLiquidacion = this.rechazarLiquidacion.bind(this);
              }

  ngOnInit() {
    this.getIdLiquidacion();
  }

  startFondo() {
    this.fondoSelected = {
      'idLiquidacion': this.idLiquidacion,
      'aportaciones': this.liquidacionSelected.aportaciones,
      'retiros': this.liquidacionSelected.retiros
    };
  }

  getIdLiquidacion() {
    this.idLiquidacion = this.activedRoute.snapshot.params.id;
    this.notasUrl = '/liquidacion-revision/' + this.idLiquidacion + '/notas-fotografias';
    this.movimientosUrl = '/liquidacion-revision/' + this.idLiquidacion +'/movimientos-obra';
    if (this.idLiquidacion) {
      this.getLiquidacion();
    } else {
      console.log('dont found id liquidacion');
      this.regresar();
    }
  }

  getLiquidacion() {
    this.liquidacionRevisionService.getLiquidacionByID(this.idLiquidacion)
      .subscribe(response => {
        const content_response = response.json().content;
        this.liquidacionSelected = content_response;
        this.liquidacionSelected.fecha_formated = this.helperService.getMonthYearByDate(this.liquidacionSelected.fechaLiquidacion);
        this.startFondo();
      }, error => {
        const content_error = error.json().content;
        // resuelve errores 403, 500 y sin internet
        this.helperService.httpGlobalError(error);

        if (error.status == 400 && content_error.id) {
          this.router.navigate(['/'])
        }
      });
  }

  confirmSaveFondo() {
    this.confirmModal.open({
      'title': 'Guardar Fondo de ahorro',
      'description': ' ¿Desea guardar el fondo de ahorro correspondiente a la obra ' + this.liquidacionSelected.obras.nombreObra +  ' del mes de ' + this.liquidacionSelected.fecha_formated + '?',
      'callback': this.saveFondo
    })
  }

  saveFondo() {

    this.errors = [];
    this.errors = this.liquidacionRevisionService.validateFondo(this.fondoSelected);

    if (!$.isEmptyObject(this.errors)) {
      return false;
    }
    this.processing = true;
    this.liquidacionRevisionService.saveFondo(this.fondoSelected)
      .subscribe(response => {
        console.log('save fondo response ', response);
        this.successModal.open({
          'title': 'Fondo de ahorro guardado',
          'description': 'El fondo de ahorro de la obra ' + this.liquidacionSelected.obras.nombreObra +  ' del mes de ' + this.liquidacionSelected.fecha_formated + ' fue guardado con éxito.'
        });
        this.changing = false;
        this.processing = false;
        this.getLiquidacion();
      }, error => {
        console.log('save fondo error ', error);
        this.helperService.httpGlobalError(error, false);

        if (error == 400 || error == 500) {
          // usamos modal en vez de notification
          this.errorModal.open({
            'title': 'ERROR',
            'description': 'No se pudo completar la acción solicitada. Por favor, intente más tarde.'
          });
        }
      })
  }

  confirmAprobarLiquidacion() {
    this.confirmModal.open({
      'title': 'Aprobar liquidación',
      'description': 'Aprobación<br/> ¿Está seguro que desea aprobar esta liquidación?',
      'color': 'success',
      'text': 'Enviar',
      'callback': this.aprobarLiquidacion
    });
  }

  aprobarLiquidacion() {
    this.liquidacionRevisionService.aprobarLiquidacion(this.liquidacionSelected.idLiquidacion)
      .subscribe(response => {
        const content_response = response.json().content;
        this.helperService.notification('Liquidación Aprobada', 'Se aprobó la Liquidación de ' + this.liquidacionSelected.obras.nombreObra +  ' del mes de ' + this.liquidacionSelected.fecha_formated + '?', 'success');
        this.regresar()
      }, error => {
        console.log('error sendLiquidación ', error);
        this.helperService.httpGlobalError(error);
      })
  }

  confirmRechazarLiquidacion() {
    this.confirmTextModal.open({
      'title': 'Rechazar liquidación',
      'description': 'Por favor, capture un motivo del rechazo',
      'color': 'danger',
      'buttonText': 'Enviar',
      'textRequired': true,
      'textSize': 600,
      'callback': this.rechazarLiquidacion
    });
  }

  rechazarLiquidacion() {
    const data = {
      'idLiquidacion': this.idLiquidacion,
      'notasRechazo': this.notasRechazo
    }
    this.liquidacionRevisionService.rechazarLiquidacion(data)
      .subscribe(response => {
        const content_response = response.json().content;
        this.helperService.notification('Liquidación Rechazada', 'Se rechazó la Liquidación de ' + this.liquidacionSelected.obras.nombreObra +  ' del mes de ' + this.liquidacionSelected.fecha_formated + '?', 'success');
        this.regresar()
      }, error => {
        console.log('error sendLiquidación ', error);
        this.helperService.httpGlobalError(error);
      })
  }

  confirmSendLiquidacion() {
    this.confirmModal.open({
      'title': 'Liquidación',
      'description': 'Enviar a revisión <br/> ¿Desea enviar a revisión la Liquidación de ' + this.liquidacionSelected.obras.nombreObra +  ' del mes de ' + this.liquidacionSelected.fecha_formated + '?',
      'color': 'success',
      'text': 'Enviar',
      'callback': this.sendLiquidacion
    });
  }

  sendLiquidacion() {
    this.liquidacionRevisionService.sendLiquidacion(this.liquidacionSelected.idLiquidacion)
      .subscribe(response => {
        const content_response = response.json().content;
        this.helperService.notification('Liquidación Enviada', 'Se ha enviado a revisión la Liquidación de ' + this.liquidacionSelected.obras.nombreObra +  ' del mes de ' + this.liquidacionSelected.fecha_formated + '?', 'success');
        this.regresar()
      }, error => {
        console.log('error sendLiquidación ', error);
        this.helperService.httpGlobalError(error);
      })
  }

  confirmCancelChanges() {
    if (this.changing) {
      this.confirmModal.open({
        'title': 'Cancelar cambios',
        'description': '¿Está seguro de cancelar los cambios?',
        'callback': this.cancelChanges,
        'color': 'danger'
      });
    } else {
      this.cancelChanges();
    }
  }

  cancelChanges() {
    this.changing = false;
    this.startFondo();
  }

  confirmDeleteLiquidacion() {
    this.confirmModal.open({
      'title': 'Eliminar liquidación',
      'description': '¿Desea eliminar la liquidación ' + this.liquidacionSelected.obras.nombreObra +  ' del mes de ' + this.liquidacionSelected.fecha_formated + '?',
      'callback': this.deleteLiquidacion,
      'color': 'danger'
    });
  }
  deleteLiquidacion() {
    this.liquidacionRevisionService.deleteLiquidacion(this.idLiquidacion)
      .subscribe(response => {
        console.log('delete liq response ', response);
        this.helperService.notification('Liquidación eliminada', 'La liquidación ha sido eliminada.', 'success');
        this.regresar();
      }, error => {
        this.helperService.httpGlobalError(error);
      })
  }

  fotografiaSelectedWithId() {
    if (! this.fondoSelected) {
      return false;
    }

    return (this.fondoSelected.idLiquidacion_Imagenes);
  }

  regresar() {
    console.log('regresando a vista anterior');
    this.router.navigate(["/liquidacion-revision"]);
  }
  hasNotasRechazo() {
    return this.liquidacionSelected && this.liquidacionSelected.estado == 2 && this.liquidacionSelected.notasRechazo;
  }
  // MODAL FUNCTIONS

  modalCallback(callback){
    callback();
  }

  modalConfirmTextCallback(data) {
    this.notasRechazo = data.text;
    data.callback();
  }

  // MAIN SECTIONS FUNCTIONS

  mainContainerClass(){
    return (this.mostrarListado)?"col-12":"offset-2 col-8";
  }

  mainTableClass(){
    return (this.mostrarListado)?"col-8":"col-4";
  }

  mainDetailsClass(){
    return (this.mostrarListado)?"col-4":"col-8";
  }

  canEdit() {
    return (this.liquidacionSelected && this.liquidacionSelected.isDate && this.liquidacionSelected.estado == 1);
  }

  writePermission() {
    return this.liquidacionRevisionService.writePermission();
  }

}



// WEBPACK FOOTER //
// ./src/app/components/liquidacion-revision/liquidacion-revision-fondo-ahorro/liquidacion-revision-fondo-ahorro.component.ts